import Login from '../components/Login/Login';
import LoginFormContainer from '../containers/LoginFormContainer';
import UsernameFormContainer from '../containers/UsernameFormContainer';
import SecurityCodeFormContainer from '../containers/SecurityCodeFormContainer';
import ResetPasswordFormContainer from '../containers/ResetPasswordFormContainer';

export const adminRoutes = {
    path: '/signin/admin',
    component: Login,
    routes: [{
        path: '/signin/admin/check-username',
        component: UsernameFormContainer,
        exact: true
    }, {
        path: '/signin/admin/reset-password-code',
        component: SecurityCodeFormContainer,
        exact: true
    }, {
        path: '/signin/admin/reset-password',
        component: ResetPasswordFormContainer,
        exact: true
    }, {
        path: '/signin/admin',
        component: LoginFormContainer,
        exact: true
    }]
};

export const nonAdminRoutes = {
    path: '/signin',
    component: Login,
    routes: [{
        path: '/signin/check-username',
        component: UsernameFormContainer,
        exact: true
    }, {
        path: '/signin/reset-password-code',
        component: SecurityCodeFormContainer,
        exact: true
    }, {
        path: '/signin/reset-password',
        component: ResetPasswordFormContainer,
        exact: true
    }, {
        path: '/signin',
        component: LoginFormContainer,
        exact: true
    }]
};
